import React from "react";
import "../css/style.css";
import { Button } from "@material-ui/core";
import Pagination from "@mui/material/Pagination";

import { userActions } from "../_actions";
import { userService } from "../_services";
import { connect } from "react-redux";
import i18next from "i18next";
import { CircularProgress } from "@material-ui/core";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { confService } from "../_services";
import PartItem from "./PartItem";
import { ConferenceNotSelected } from "../_components/ConferenceNotSelected";
import { serverUrl } from "../_constants";
import { responseErrorToText } from "../_helpers/error";
import { showGlobalSnackbar, showGlobalConfirm } from "../_services/snackbarService";

class PartPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      team: [],
      nameF: "",
      confF: "",
      ticketF: "",
      dateF: "",
      sortNameDesc: false,
      conferenceId: (props.conferenceId && props.conferenceId !== '0') ? props.conferenceId : 0,
      isOrg: props.user.info.type === "org",
      itemsOnPage: 20,
      pagesCount: 0,
      page: 1,
    };
  }

  componentDidMount() {
    if (!this.props.singleConf || this.props.conferenceId) {
      this.getStudents(this.state.conferenceId, this.state.page, this.state.itemsOnPage);
    }
  }

  downloadList = () => { //скачивание списка в csv (только для орга в отдельной конфе и для студента)
    if (!this.state.conferenceId) return;

    userService.getWrapper(
      "api/conference/" + this.state.conferenceId + "/students-export" + (this.props.user.info.type === "student" ? "?forStudent=1" : ""),
      (data) => {
        console.log(data.data);
        if (data.data) window.open(data.data, "_blank");
      },
      (error) => {
        //dispatch(userActions.set_error(error));
      }
    );
  };

  getStudents = (conferenceId, pageNum=0, pageSize=0) => {
    const self = this;
    const isStudent = this.props.user.info.type === "student";

    confService.confListStudents(
      (data,itemsCount) => {
        self.setState({
          team: [...data],
          isLoading: false,
          conferenceId: (conferenceId && conferenceId !== '0') ? conferenceId : 0,
          isStudent,
          pagesCount: Math.ceil(itemsCount/this.state.itemsOnPage),
        });
      },
      pageNum,
      pageSize,
      conferenceId,
      isStudent,
    );
  };

  cancelTicket = (e) => { //аннулирование билета
    let self = this;

    showGlobalConfirm(i18next.t("cancel_ticket") + "?").then((ok) => {
      if (!ok) return;
      userService.postWrapper(
        "api/ticket/cancel/" + e.id,
        {},
        (data) => {
          this.getStudents(this.state.conferenceId, this.state.page, this.state.itemsOnPage);
          //userActions.set_error(i18next.t("for_ticket_paid_write_to_nc"), "info")
        },
        (error) => {
          if (error != "") {
            self.setState({ error, isLoading: false });
            self.props.dispatch(userActions.set_error(error));
          } else {
            self.setState({ isLoading: false });
          }
        }
      );
    });
  };

  downloadBadge = (e) => {
    confService.downloadBadge(
      e.conf_id,
      e.user_id,
      (data) => {
        if (data.data) {
          var wnd = window.open(serverUrl + data.data);
          wnd.print();
        }
      },
      (error) => {
        showGlobalSnackbar(responseErrorToText(error), "error");
      }
    );
  };

  editFilter = (name, val) => {
    if (name === "name") this.setState({ nameF: val });
    else if (name === "conf") this.setState({ confF: val });
    else if (name === "date") this.setState({ dateF: val });
    else if (name === "ticket") this.setState({ ticketF: val });
  };

  handleChangePage = (e,value) =>{ //смена страницы при пагинации
    console.log(value);
    this.setState({page:value});
    this.getStudents(this.state.conferenceId, value, this.state.itemsOnPage);
  }

  render() {
    const self = this;
    const {
      isLoading,
      team,
      nameF,
      confF,
      dateF,
      ticketF,
      sortNameDesc,
      isOrg,
      pagesCount,
      page,
    } = this.state;
    const forStudent = this.props.user.info.type === "student";
    const isSingleConf = this.props.singleConf;

    if (isSingleConf && !this.props.conferenceId) {
      return (
        <div className="layout">
          <ConferenceNotSelected 
            page={"confpartips"} isGlobalSelector={true} globalSelectorWithoutChangePage={true}
            onChange={conferenceId => this.getStudents(conferenceId, 1, this.state.itemsOnPage)}
          />
        </div>
      );
    }

    const downloadListButton = this.state.conferenceId && (forStudent || isSingleConf)
      ? (<div>
          <Button onClick={self.downloadList}>
            {i18next.t("download_list")}
          </Button>
        </div>) : "";

    return (
      <div className="layout">
        <div className="layout__contains">
          <h1 className="layout__title">
            {i18next.t(isSingleConf ? "confpartips" : "partips")}
            {isSingleConf ? " " + this.props.conf_name : ""}
          </h1>
          {downloadListButton}
        </div>
        {forStudent && (
          <ConferenceNotSelected 
            page={"partips"} forStudent={true} isGlobalSelector={false}
            onChange={conferenceId => this.getStudents(conferenceId, 1, this.state.itemsOnPage)} 
          />
        )}
        <div className="tbl">
          <div className="tbl__top part-table__top">
            <div className="tbl__items part-table__items">
              {isOrg && <div className="part-table__avatar-col"></div>}
              <div className="tbl__item tbl__item--city part-table__name">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    onClick={() =>
                      this.setState({ sortNameDesc: !sortNameDesc })
                    }
                  >
                    {sortNameDesc ? (
                      <ExpandLess fontSize="large" />
                    ) : (
                      <ExpandMore fontSize="large" />
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder={i18next.t("search_for_name")}
                    value={nameF}
                    onChange={(e) => self.editFilter("name", e.target.value)}
                  />
                </div>
              </div>
              <div className="tbl__item tbl__item--city part-table__conf">
                <input
                  type="text"
                  placeholder={i18next.t("search_for_event")}
                  value={confF}
                  onChange={(e) => self.editFilter("conf", e.target.value)}
                />
              </div>
              <div className="tbl__item part-table__details"></div>
              {!forStudent && (
                <div className="tbl__item tbl__item--text part-table__ticket">
                  <input
                    type="text"
                    placeholder={i18next.t("search_by_ticket")}
                    value={ticketF}
                    onChange={(e) => self.editFilter("ticket", e.target.value)}
                  />
                </div>
              )}
              {!forStudent && (
                <div className="tbl__item tbl__item--text part-table__date">
                  <input
                    type="text"
                    placeholder={i18next.t("date_search")}
                    value={dateF}
                    onChange={(e) => self.editFilter("date", e.target.value)}
                  />
                </div>
              )}
              {!forStudent && (
                <div className="part-table__actions-col"></div>
              )}
            </div>
          </div>

          <div className="tbl__body">
            {team.length > 0 &&
              team
                .filter(function (e) {
                  if (!e) return false;

                  return (
                    (e.user_name || "")
                      .toLowerCase()
                      .indexOf(nameF.toLowerCase()) >= 0 &&
                    (e.conf_name || "")
                      .toLowerCase()
                      .indexOf(confF.toLowerCase()) >= 0 &&
                    (e.updated_at || "")
                      .toLowerCase()
                      .indexOf(dateF.toLowerCase()) >= 0 &&
                    (e.ticket_name || "")
                      .toLowerCase()
                      .indexOf(ticketF.toLowerCase()) >= 0
                  );
                })
                .sort(function (a, b) {
                  var nameA = (a.user_name || "").toLowerCase(),
                    nameB = (b.user_name || "").toLowerCase();

                  if (!sortNameDesc) {
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                  } else {
                    if (nameA < nameB) return 1;
                    if (nameA > nameB) return -1;
                    return 0;
                  }
                })
                .map((item, index) => (
                  <PartItem
                    data={item}
                    forStudent={forStudent}
                    downloadBadge={() => self.downloadBadge(item)}
                    cancelTicket={() => self.cancelTicket(item)}
                    isOrg={isOrg}
                    conferenceId={this.state.conferenceId}
                  />
                ))}
          </div>
        </div>
        
           <Pagination count={pagesCount} page={page} onChange={this.handleChangePage} />
        
        
        {isLoading && (
          <div className="shadow">
            <div className="shadow_circle">
              <CircularProgress />
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, user, authentication, studentConferences } = state;

  return {
    user,
    app,
    authentication,
    studentConferences,
  };
}

const connectedPartPage = connect(mapStateToProps)(PartPage);
export { connectedPartPage as PartPage };
